import actionTypes from 'SRC/modules/redux/actionTypes'

export const setProfileAdsError = error => ({
  type: actionTypes.SET_PROFILE_ADS_ERROR,
  payload: error
})
